// src/store/useGlobalStore.js
import { create } from "zustand";
import axios from "../helper/axios"; // Import the shared instance
import { resetActiveTimer,notifyActiveTimeout } from "../helper/idleTimer";
import { resetLogOutTimer } from "../helper/logoutTimer";

// Helper function to create the artificial delay
// const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const useGlobalStore = create((set, get) => ({
  // Global State
  isLoading: false,
  forcedLogoutFlag:false,

  setLoading: (status) => set({ isLoading: status }),
  setForcedLogoutFlag: () => set({ forcedLogoutFlag: true }),
  resetForcedLogoutFlag: () => set({ forcedLogoutFlag: false }),

  // Interceptor Setup
  setupInterceptors: () => {
    let activeRequests = 0;

    // REQUEST Interceptor: Show loading spinner
    const requestInterceptor = axios.interceptors.request.use(
      (config) => {
        if(!get().forcedLogoutFlag)
          resetActiveTimer(notifyActiveTimeout);
        
        resetLogOutTimer(() => get().setForcedLogoutFlag());
        
        // --- MODIFICATION HERE: Check for the exclusion flag ---
        if (config._ignoreLoading) {
          return config; // Skip loading logic
        }
        activeRequests++;
        get().setLoading(true); // Show spinner
        return config;
      },
      (error) => {
        // The error path also needs the check
        if (!error.config._ignoreLoading) {
          activeRequests--;
          if (activeRequests === 0) get().setLoading(false);
        }
        return Promise.reject(error);
      }
    );

    // RESPONSE Interceptor: Hide loading spinner (with delay)
    const responseInterceptor = axios.interceptors.response.use(
      async (response) => {
        if(!get().forcedLogoutFlag)
          resetActiveTimer(notifyActiveTimeout);
        
        resetLogOutTimer(() => get().setForcedLogoutFlag());
        // --- START: 1-SECOND DELAY FOR TESTING ---
        // await delay(500); // Wait for 1000 milliseconds (1 second)
        // --- MODIFICATION HERE: Check for the exclusion flag ---
        if (response.config._ignoreLoading) {
          return response; // Skip loading logic
        }
        activeRequests--;
        if (activeRequests === 0) get().setLoading(false);
        return response;
      },
      async (error) => {
        if(!get().forcedLogoutFlag)
          resetActiveTimer(notifyActiveTimeout);

        resetLogOutTimer(() => get().setForcedLogoutFlag());
        // --- START: 1-SECOND DELAY FOR TESTING (Error path) ---
        // await delay(1000); // Keep for testing

        // --- MODIFICATION HERE: Check for the exclusion flag ---
        if (!error.config._ignoreLoading) {
        activeRequests--;
        if (activeRequests === 0) get().setLoading(false);
        }
        return Promise.reject(error);
      }
    );

    // Cleanup function
    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  },
}));
